// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import accordion from "@stoneage/XDL/PreStyle/accordion";
import breadcrumbs from "@stoneage/XDL/PreStyle/breadcrumbs";
import breakpoints from "@stoneage/XDL/PreStyle/breakpoints";
import button from "@stoneage/XDL/PreStyle/button";
import checkbox from "@stoneage/XDL/PreStyle/checkbox";
import colors from "@stoneage/XDL/PreStyle/colors";
import dataTable from "@stoneage/XDL/PreStyle/dataTable";
import datePicker from "@stoneage/XDL/PreStyle/datePicker";
import drawer from "@stoneage/XDL/PreStyle/drawer";
import dynamicDropdown from "@stoneage/XDL/PreStyle/dynamicDropdown";
import focus from "@stoneage/XDL/PreStyle/focus";
import formField from "@stoneage/XDL/PreStyle/formField";
import globalStyle from "@stoneage/XDL/PreStyle/globalStyle";
import helpers from "@stoneage/XDL/PreStyle/helpers";
import link from "@stoneage/XDL/PreStyle/link";
import lists from "@stoneage/XDL/PreStyle/lists";
import loadingSpinner from "@stoneage/XDL/PreStyle/loadingSpinner";
import menu from "@stoneage/XDL/PreStyle/menu";
import modal from "@stoneage/XDL/PreStyle/modal";
import overflowMenu from "@stoneage/XDL/PreStyle/overflowMenu";
import pagination from "@stoneage/XDL/PreStyle/pagination";
import panelMenu from "@stoneage/XDL/PreStyle/panelMenu";
import radio from "@stoneage/XDL/PreStyle/radio";
import select from "@stoneage/XDL/PreStyle/select";
import tab from "@stoneage/XDL/PreStyle/tab";
import tag from "@stoneage/XDL/PreStyle/tag";
import toast from "@stoneage/XDL/PreStyle/toast";
import tooltip from "@stoneage/XDL/PreStyle/tooltip";
import typography from "@stoneage/XDL/PreStyle/typography";
import zIndex from "@stoneage/XDL/PreStyle/zIndex";
import { xBaseTheme } from "@stoneage/XDL/types";
import icon from "@stoneage/XDL/PreStyle/icon";

export default {
    breakpoints,
    colors,
    focus,
    // shadows,
    // transition,
    globalStyle,
    typography,
    zIndex,
    accordion,
    breadcrumbs,
    button,
    checkbox,
    // clickable,
    dataTable,
    datePicker,
    drawer,
    dynamicDropdown,
    // fileUpload,
    formField,
    // fieldSet,
    icon,
    link,
    lists,
    // lazyImage,
    loadingSpinner,
    menu,
    modal,
    overflowMenu,
    pagination,
    panelMenu,
    radio,
    select,
    tab,
    tag,
    // textField,
    // tokenExFrame,
    // textArea,
    toast,
    tooltip,
    // translate,
    helpers,
} as xBaseTheme;
